import React, { useMemo } from 'react';
import { Progress, Rate } from 'tea-component';
import { reviewsFormat, scoreFormat } from '@op/utils/value';
import ChannelLabel from '@op/components/ChannelLabel';
import { useHistory, useIntl } from 'umi';
import classNames from 'classnames';
import './index.scss';

export default function Ratings({ renderList = [] }: any) {
  const { formatMessage } = useIntl();
  const history = useHistory();
  return (
    <div className="dbo-metrics-gamestore-ratings">
      {renderList.map((item) => {
        return ['metacritic', 'opencritic'].includes(item.channel) ? (
          <CriticElement
            {...item}
            formatMessage={formatMessage}
            className={`max-card-${renderList.length}`}
            history={history}
          ></CriticElement>
        ) : (
          <StarElement {...item} formatMessage={formatMessage} history={history}></StarElement>
        );
      })}
    </div>
  );
}

function StarElement({ review, score, channel, formatMessage, history }: any) {

  return (
    <div className="gamestore-ratings-card" onClick={() => history.push(`/opinion/GameStore?tab=${channel}`)}>
      <div className="gamestore-ratings-card-content">
        <div className="gamestore-ratings-card-img">
          <ChannelLabel channel_name={channel} showText={false}></ChannelLabel>
        </div>
        <div className="gamestore-ratings-card-value star-value">
          {scoreFormat(score)}
        </div>
      </div>
      <div className="dbo-scorebox-reviewbox">
        <Rate
          readonly
          allowHalf
          theme="primary"
          defaultValue={score}
          size="m"
        />
        <div className="bubble-common-child-wrapper no-pointer">
          <div className="dbo-scorebox-text">
            {reviewsFormat(review, 2, '0')} {formatMessage({ id: 'Reviews-1' })}
          </div>
        </div>
      </div>
    </div>
  );
}

function CriticElement({
  review,
  score,
  channel,
  formatMessage,
  className,
  history
}: any) {
  const text = channel === 'metacritic' ? 'Meta Score' : 'Top Critic Avg';

  return (
    <div className={classNames(className, 'gamestore-ratings-critic-card')} onClick={() => history.push('/opinion/GameStore?tab=opencritic-metacritic')}>
      <div className="gamestore-ratings-critic-card-content">
        <div className="gamestore-ratings-critic-card-img">
          <ChannelLabel channel_name={channel}></ChannelLabel>
        </div>
        <div className="bubble-common-child-wrapper no-pointer">
          <div className="dbo-scorebox-text">{text}</div>
          <div className="dbo-scorebox-text">
            {reviewsFormat(review, 2, '0')} {formatMessage({ id: 'Reviews-1' })}
          </div>
        </div>
      </div>
      <div className="dbo-scorebox-reviewbox">
        <div className="dbo-scorebox-reviewbox-value">
          <Progress
            theme="default"
            type="circle"
            text={score + ''}
            percent={score}
            strokeColor="#326FF0"
            strokeWidth={5}
            width={60}
          />
        </div>
      </div>
    </div>
  );
}
